"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var compare_versions_component_1 = require("./../../compare-versions/compare-versions.component");
var rxjs_1 = require("rxjs");
var terms_dialog_component_1 = require("./../../terms-dialog/terms-dialog.component");
var material_1 = require("@angular/material");
var forms_1 = require("@angular/forms");
var image_attach_component_1 = require("./../../../../Components/image-attach/image-attach.component");
var send_conversation_message_component_1 = require("./../../../../Components/send-message/send-conversation-message.component");
var conversationService_1 = require("./../../../../Services/conversationService");
var service_service_1 = require("src/app/Services/service.service");
var core_1 = require("@angular/core");
var EmojiHelper_1 = require("../../../../Helpers/EmojiHelper");
var TextinputBarComponent = /** @class */ (function (_super) {
    __extends(TextinputBarComponent, _super);
    function TextinputBarComponent(mainService, conversationService, fb, matDialog) {
        var _this = _super.call(this, mainService, null) || this;
        _this.mainService = mainService;
        _this.conversationService = conversationService;
        _this.fb = fb;
        _this.matDialog = matDialog;
        _this.restartImagesCount = new rxjs_1.Subject();
        _this.submitInitialMessage = new core_1.EventEmitter();
        _this.reloadMessages = new core_1.EventEmitter();
        _this.nickVisible = false;
        _this.acceptTermsEnable = false;
        _this.newConv = false;
        _this.textMessage = '';
        _this.controlNames = [
            { name: 'nickname', title: 'Nick' },
            { name: 'messagecontent', title: 'Message content' },
            { name: 'termsaccept', title: "Terms Accept" }
        ];
        return _this;
    }
    TextinputBarComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.currentConversation) {
            this.service.advService.getAdvertisementData(this.currentConversation.advertisementId).then(function (advGet) {
                var advertisement = advGet.adveristments[0];
                if (advertisement && advertisement.userId == _this.service.userService.getUserId() && advertisement.images.length > 0)
                    _this.advImagesCount = advertisement.images.length;
            });
        }
        if (this.newConversationAdvId) {
            this.newConv = true;
        }
        this.messageForm = this.fb.group({
            messagecontent: [null, forms_1.Validators.required],
            nickname: [null, this.nickVisible ? forms_1.Validators.required : null],
            termsaccept: [false, forms_1.Validators.required],
        });
    };
    TextinputBarComponent.prototype.showTermsDialog = function (event) {
        event.preventDefault();
        var item = this.matDialog.open(terms_dialog_component_1.MobileTermsDialogComponent, {
            width: '1000%',
            maxHeight: '100%',
            height: "82vh",
            panelClass: "TermsDialogComponent-panel",
            data: {
                isPopup: true
            }
        });
        item.componentInstance.isPopup = true;
        return false;
    };
    TextinputBarComponent.prototype.showCompareVersions = function () {
        var item = this.matDialog.open(compare_versions_component_1.MobileCompareVersionsComponent, {
            width: "80%",
            height: "810px",
            panelClass: "CompareVersionsComponent-panel",
            data: {
                isPopup: true,
                title: "Upgrade To Premium to send unlimited pictures"
            }
        });
        item.componentInstance.isPopup = true;
    };
    TextinputBarComponent.prototype.onCheckChange = function (e) {
        this.messageForm.patchValue({
            termsaccept: e.checked
        });
    };
    TextinputBarComponent.prototype.getInvalidFields = function () {
        var _this = this;
        var result = this.controlNames.map(function (control) {
            return { controlItem: control, control: _this.messageForm.controls[control.name] };
        }).filter(function (c) { return c.control != null && !c.control.valid; });
        return result.map(function (c) { return c.controlItem.title; });
    };
    TextinputBarComponent.prototype.showMaxAttachmentsExceeded = function () {
        this.showCompareVersions();
    };
    TextinputBarComponent.prototype.updateMessage = function (text) {
        this.textMessage = text;
    };
    TextinputBarComponent.prototype.clear = function () {
        this.textMessage = '';
        this.imageAttachComponent.clear();
        this.restartImagesCount.next(0);
    };
    Object.defineProperty(TextinputBarComponent.prototype, "nick", {
        get: function () {
            if (this.messageForm.controls["nickname"].value == null) {
                return "";
            }
            return this.messageForm.controls["nickname"].value;
        },
        set: function (value) {
            if (!this.isSpecialUser && !this.PremiumAdvertisementMessages) {
                value = EmojiHelper_1.removeEmojis(value);
            }
            this.messageForm.controls["nickname"].setValue(value);
        },
        enumerable: true,
        configurable: true
    });
    //TODO typ dla conversationId zwracane sa dwa
    TextinputBarComponent.prototype.sendMessage = function (textMessage, conversationId) {
        var _this = this;
        if ((this.isNotFirstMessage && this.imagesIsUploaded) || this.messageForm.valid) {
            this.conversationMessageContent = textMessage.trim();
            if (textMessage.trim().length < 4000) {
                if (!this.newConv) {
                    this.nick = this.currentConversation.senderNick;
                    var messageParams = this.prepareMessageParams();
                    this.submitStart();
                    this.conversationService.sendMessageToExistingConversation(this.mainService.userService.getUserId(), messageParams.content, this.currentConversation.conversationId, messageParams.images).then(function (result) {
                        _this.conversationService.getConversation(conversationId).then(function (conversation) {
                            _this.submitFinished();
                            var thanksInfo = _this.mainService.showInformation("Your message has been sent");
                            setTimeout(function () {
                                thanksInfo.dismiss();
                                _this.reloadMessages.emit(conversation);
                                _this.clear();
                            }, 1000);
                        });
                    }).catch(function (err) {
                        _this.mainService.showError(err);
                        _this.submitFinished();
                    });
                }
                else {
                    this.submitInitialMessage.emit(this);
                }
            }
            else {
                this.service.showError("The maximum length of the message is 4000 characters");
            }
        }
        else {
            this.mainService.showError("Some fields are invalid, fill them properly: " + this.getInvalidFields().join(","));
            return false;
        }
    };
    return TextinputBarComponent;
}(send_conversation_message_component_1.SendConversationMessageComponent));
exports.TextinputBarComponent = TextinputBarComponent;
